import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function ChangePassword() {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const navigate = useNavigate();
  const { logout } = useAuth();

  const submit = async (e) => {
    e.preventDefault();
    if (next !== confirm) return toast.error("Le password non corrispondono");
    if (next.length < 8) return toast.error("La password deve essere di almeno 8 caratteri");
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password aggiornata. Riesegui l'accesso.");
      await logout();
      navigate("/login");
    } catch (e) { toast.error(e.response?.data?.detail || "Errore"); }
  };

  return (
    <div className="max-w-md mx-auto">
      <h1 className="text-3xl font-extrabold tracking-tight mb-6">Cambia password</h1>
      <Card><CardContent className="p-6">
        <form onSubmit={submit} className="space-y-4">
          <div><Label>Password attuale</Label>
            <Input type="password" required value={current} onChange={(e) => setCurrent(e.target.value)} data-testid="cp-current" /></div>
          <div><Label>Nuova password (min. 8)</Label>
            <Input type="password" required minLength={8} value={next} onChange={(e) => setNext(e.target.value)} data-testid="cp-new" /></div>
          <div><Label>Conferma nuova password</Label>
            <Input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="cp-confirm" /></div>
          <Button type="submit" data-testid="cp-submit" className="w-full bg-amber-500 hover:bg-amber-600 text-slate-950 font-semibold">Aggiorna password</Button>
        </form>
      </CardContent></Card>
    </div>
  );
}
